import { getSubRoutes } from "./getSubRoutes"

import { isBrowser } from "@utils/infrastructure/ssg-utils"

export function getCurrentParams() {
    if (!isBrowser()) return
    const { params } = getSubRoutes(location.pathname)
    return params
}
